import React from "react";
import { Container, Grid, Link } from "@mui/material";
import Heading from "../../components/Heading/heading";

import twitter from '../../image/twitter.png'
import telegram from '../../image/telegram.png'
import ETHScan from '../../image/ETHScan.png'
import CMC from '../../image/CMC.png'
import CG from '../../image/CG.png'
import header_img from '../../image/header_img.png'


const Header = () => {
    return(
        <div className="SP---header mb-4">
            <Container maxWidth="lg">
                <Grid
                    container
                    justifyContent='flex-start'
                    alignItems="center"
                >
                    <Grid
                        xs={12}
                        sm={8}
                    >
                        <Heading
                            subtitle="Shiba Puppy"
                            title="Because Elon asked for it. His favorite puppy is here!"
                            mWidth="500px"
                        />
                        <div>
                            <Link 
                                href="https://pancakeswap.finance/swap#/swap?inputCurrency=0x8203612382f61bafae549fbf31efbf70992fa289"
                                className="SP---header--buy-btn btn px-3 py-2 mb-4"
                                target="_blank"
                            >
                                Buy on Pancake
                            </Link>
                            <Link 
                                href="https://www.cointiger.com/en-us/#/trade_center?coin=shibapup_usdt" 
                                className="SP---header--buy-btn btn px-3 py-2 mb-4 ml-sm-3"
                                target="_blank"
                            >
                                Buy on CoinTiger
                            </Link>
                            <Link 
                                href="https://www.bitmart.com/trade/en?layout=pro&symbol=SHIBAPUP_USDT" 
                                className="SP---header--buy-btn MT btn px-3 py-2 mb-4 ml-md-3"
                                target="_blank"
                            >
                                Buy on BitMart
                            </Link>
                        </div>
                        <div>
                            <Link href="https://twitter.com/shibapupdog" target="_blank">
                                <img src={twitter} className="img-fluid w-100" style={{maxWidth:40}} />
                            </Link>
                            <Link href="https://t.me/shibapupdog" target="_blank">
                                <img src={telegram} className="img-fluid w-100 ml-2" style={{maxWidth:40}} />
                            </Link>
                            <Link href="https://bscscan.com/token/0x8203612382f61bafae549fbf31efbf70992fa289" target="_blank">
                                <img src={ETHScan} className="img-fluid w-100 ml-2" style={{maxWidth:40}} />
                            </Link>
                            <Link href="https://coinmarketcap.com/currencies/shibapup" target="_blank">
                                <img src={CMC} className="img-fluid w-100 ml-2" style={{maxWidth:40}} />
                            </Link>
                            <Link href="https://www.coingecko.com/en/coins/shibapup" target="_blank">
                                <img src={CG} className="img-fluid w-100 ml-2" style={{maxWidth:40}} />
                            </Link>
                        </div>
                    </Grid>
                    <Grid
                        xs={12}
                        sm={4}
                        className="text-center"
                    >
                        <img src={header_img} className="img-fluid w-100 mt-4" style={{maxWidth: 300}} />
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Header;